<div class="container">

  <div class="cardBox " *ngIf="checkType!='add'">

    <!-- <p style="text-align: center;"><em>(Applicable for Officer & Above Level Management Staff)</em></p> -->
    <ion-row>
      <ion-col size="10">
        <div>
          <h2 style="text-align: center; margin-left: 28%;">Probation and Confirmation Form</h2>
        </div>
      </ion-col>
      <ion-col size="2" class="text-right">
        <img (click)="closeModal()" class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>
    <div style="max-height: 112vh; overflow: auto; padding: 20px; border: 1px solid #ccc;">


      <ion-row class="ion-padding" style="border: 1px solid #ccc; border-radius: 8px; font-size: 16px;">
        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Name:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.empName||employee?.empName }}</div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Empl. Code:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.emplCode ||employee?.emplCode }}</div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Band:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.band||employee?.band }}</div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Grade:</div>
            <div class="value">{{lineManagerOrHODData[0]?.grade||employee?.grade }}</div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Designation:</div>
            <div class="value">{{lineManagerOrHODData[0]?.empDesignation ||employee?.empDesignation }}</div>
          </div>
        </ion-col>



        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Department:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.empDept||employee?.empDept }}</div>
          </div>
        </ion-col>

        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Education:</div>
            <div class="value">{{lineManagerOrHODData[0]?.finalEducation ||employee?.finalEducation }}</div>
          </div>
        </ion-col>

        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Experience:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.experience||employee?.experience }}</div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Date Of Joining:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.dateOfJoining||employee?.dateOfJoining | date: 'dd-MM-yyyy' }}</div>
          </div>
        </ion-col>
        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Probation Due On:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.dateOfConfirmation||employee?.dateOfConfirmation | date: 'dd-MM-yyyy' }}</div>
          </div>
        </ion-col>

        <ion-col size="12" size-md="6" class="uniform-col">
          <div class="key-value-pair">
            <div class="key">Present Salary:</div>
            <div class="value">{{ lineManagerOrHODData[0]?.presentSalary||employee?.presentSalary }}</div>
          </div>
        </ion-col>


      </ion-row>


      <p style="padding-top: 10px; font-size: 14px; line-height: 1.5;">
        The employee mentioned above is due to be confirmed in service on the date indicated above.
        You are therefore, requested to carefully evaluate his job performance as under and return this form
        to the HR & Administration Department positively within one week from the date of its receipt.
      </p>

      <div class="mt-10" style="overflow: hidden; border-radius: 10px; border: 1px solid #ccc;">
        <table border="1" cellpadding="8" cellspacing="0"
          style="width: 100%; border-collapse: collapse; text-align: center;">
          <thead>
            <tr style="font-weight: bold; background-color: #f2f2f2">
              <td class="p-10" rowspan="2">Sl</td>
              <td class="p-10" rowspan="2">Traits</td>
              <td class="p-10" colspan="5">Points to be Evaluated</td>
            </tr>
            <tr>
              <td class="p-10">Outstanding</td>
              <td class="p-10">Very Good</td>
              <td class="p-10">Good</td>
              <td class="p-10">Average</td>
              <td class="p-10">Below Average</td>
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of ratings; let i = index">
              <td class="p-10">{{ i + 1 }}</td>
              <td class="p-10" style="text-align: left;">{{ item.traitName }}</td>
              <td class="p-10">
                <input type="checkbox" [(ngModel)]="ratings[i].outstanding" class="readonly-checkbox" />
              </td>
              <td class="p-10">
                <input type="checkbox" [(ngModel)]="ratings[i].veryGood" class="readonly-checkbox" />
              </td>
              <td class="p-10">
                <input type="checkbox" [(ngModel)]="ratings[i].good" class="readonly-checkbox" />
              </td>
              <td class="p-10">
                <input type="checkbox" [(ngModel)]="ratings[i].average" class="readonly-checkbox" />
              </td>
              <td class="p-10">
                <input type="checkbox" [(ngModel)]="ratings[i].belowAverage" class="readonly-checkbox" />
              </td>
            </tr>


          </tbody>
        </table>
      </div>

      <div class="mt-10" style="overflow: hidden; border-radius: 10px; border: 1px solid #ccc;">
        <table border="1" cellpadding="8" cellspacing="0"
          style="width: 100%; border-collapse: collapse; text-align: center;">
          <thead>
            <tr>
              <td colspan="5" style="font-weight: bold; background-color: #f2f2f2" class="p-10">
                Recommended By {{confirmationProbationWhomSetup}}
              </td>
            </tr>
            <tr>
              <td class="p-10">
                <label>
                  <input type="checkbox" [(ngModel)]="recommendation.confirmation" (click)="$event.preventDefault()" />
                  Confirmation
                </label>
              </td>

              <td class="p-10">
                <label>
                  <input type="checkbox" [(ngModel)]="recommendation.extension" (click)="$event.preventDefault()" /> Extension
                  of Probation
                </label>
              </td>

              <td class="p-10">
                <label>
                  <input type="checkbox" [(ngModel)]="recommendation.promotion" (click)="$event.preventDefault()" /> Promotion
                  by Designation
                </label>
              </td>

              <td class="p-10">
                <label>
                  <input type="checkbox" [(ngModel)]="recommendation.increment" (click)="$event.preventDefault()"/> Increase Salary
                </label>
              </td>

              <td class="p-10">
                <label>
                  <input type="checkbox" [(ngModel)]="recommendation.termination" (click)="$event.preventDefault()"/>
                  Termination
                </label>
              </td>
            </tr>
          </thead>
        </table>
      </div>

      <!-- Salary Details Table -->
<!--  *ngIf="confirmationProbationWhomSetup == 'HOD'" -->
      <div class="mt-10" *ngIf="confirmationProbationWhomSetup == 'HOD'">
        <table border="1" cellpadding="8" cellspacing="0"
          style="width: 100%; border-collapse: collapse; margin-top: 10px;">
          <tr style=" background-color: #f2f2f2">
            <td style="font-weight: bold;" class="p-10">Comments of Head Of the Department</td>

          </tr>
          <tr>
            <!-- <td class="p-10">
              <textarea rows="3" cols="40" name="comments" style="border: hidden;"></textarea>
            </td> -->
            <td class="p-10">

              <textarea rows="3" cols="40" name="comments" style="border: hidden; width: 100%;" [(ngModel)]="hodComment"
                readonly></textarea>
        
            </td>

          </tr>
        </table>
      </div>
      <div class="mt-10" *ngIf="confirmationProbationWhomSetup == 'LINE_MANAGER'">
        <table border="1" cellpadding="8" cellspacing="0"
          style="width: 100%; border-collapse: collapse;  margin-top: 10px;">
          <tr style=" background-color: #f2f2f2">
            <td style="font-weight: bold;" class="p-10">Comments of Manager</td>

          </tr>
          <tr>
            <td class="p-10">
              <textarea rows="3" cols="40" name="comments" style="border: hidden;" [(ngModel)]="managerComment"
                readonly></textarea>
            </td>

          </tr>
        </table>
      </div>
      <div class="mt-10">
        <table border="1" cellpadding="8" cellspacing="0"
          style="width: 100%; border-collapse: collapse;  margin-top: 10px;">
          <tr style="background-color: #f2f2f2">
            <td style="font-weight: bold;" class="p-10">Comments of HR</td>

          </tr>
          <tr>
            <td class="p-10">
              <textarea rows="3" cols="40" name="comments" [(ngModel)]="hrComment" style="border: hidden;"
                readonly></textarea>
            </td>

          </tr>
        </table>
      </div>
      <div class="mt-10">
        <table border="1" cellpadding="8" cellspacing="0"
          style="width: 100%; border-collapse: collapse;  margin-top: 10px;">
          <tr style="background-color: #f2f2f2">
            <td style="font-weight: bold;" class="p-10">Comments of Eployee</td>

          </tr>
          <tr>
            <td class="p-10">
              <textarea rows="3" cols="40" name="comments" [(ngModel)]="employeeComment" readonly
                style="border: hidden;"></textarea>
            </td>

          </tr>


        </table>
      </div>

      <div class="mt-10">



      </div>
    </div>

  </div>


</div>